/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type BoundaryPartRequestBoundaryType =
    (typeof BoundaryPartRequestBoundaryType)[keyof typeof BoundaryPartRequestBoundaryType];

export const BoundaryPartRequestBoundaryType = {
    APPLY: 'APPLY',
    NO_APPLY: 'NO_APPLY',
    NO_ENTRY: 'NO_ENTRY'
} as const;
